import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { SvgIconComponent } from 'angular-svg-icon';

/**
 * @description
 * Core, presentation-only component for rendering a centered icon + message block
 * (e.g. server errors, empty states). Fully configurable by colors so it can be
 * reused with any palette. The message itself is projected via <ng-content>.
 *
 * Prefer the higher-level wrappers for common cases:
 * @see ServerErrorMessageComponent
 * @see NoDataMessageComponent
 */
@Component({
  selector: 'gc-error-message',
  templateUrl: './error-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SvgIconComponent, NgClass],
})
export class ErrorMessageComponent {
  public showIcon = input<boolean>(true);
  public iconSrc = input<string>('icons/icon-helper.svg');
  public iconName = input<string>('icon-helper');
  public iconSize = input<`${number}rem`>('5rem');

  /** Any valid CSS color (theme custom property by default). */
  public iconColor = input<string>('var(--p-gray-300)');
  /** Any valid CSS color (theme custom property by default). */
  public textColor = input<string>('var(--p-gray-500)');
  public styleClass = input<string>('');
}
